import { createSlice } from '@reduxjs/toolkit';
import { fetchSites, fetchStagingStatus } from '../actions/sites';

const sitesSlice = createSlice({
    name: 'sites',
    initialState: {
      data: [],
      loading: false,
      error: null,
      stagingStatus: null,
    },

    extraReducers: (builder) => {
        builder
          .addCase(fetchSites.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(fetchSites.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(fetchSites.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
          .addCase(fetchStagingStatus.fulfilled, (state, action) => {
            state.stagingStatus = action.payload;
          });
      },
    });

export default sitesSlice.reducer